import { render, staticRenderFns } from "./global-carbon-reduction-per-year.vue?vue&type=template&id=1b8601e6&scoped=true&"
import script from "./global-carbon-reduction-per-year.vue?vue&type=script&lang=js&"
export * from "./global-carbon-reduction-per-year.vue?vue&type=script&lang=js&"
import style0 from "./global-carbon-reduction-per-year.vue?vue&type=style&index=0&id=1b8601e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8601e6",
  null
  
)

export default component.exports